function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1031",
  "data-name": "Ret\\xE2ngulo 1031",
  width: 11.785,
  height: 15,
  fill: "#e2b434"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1303",
  "data-name": "Grupo 1303",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1539",
  "data-name": "Caminho 1539",
  d: "M41.406,3.028a.306.306,0,0,0,.331.192c.749-.007,1.5,0,2.247,0s1.5,0,2.247,0a.307.307,0,0,0,.326-.2c.345-.713.705-1.419,1.057-2.128.163-.329.136-.567-.077-.752a.552.552,0,0,0-.753.034,2.089,2.089,0,0,1-2.4,0,.555.555,0,0,0-.8,0,2.1,2.1,0,0,1-2.4.011c-.3-.214-.536-.231-.753-.053a.554.554,0,0,0-.091.749c.356.718.72,1.431,1.068,2.153",
  transform: "translate(-38.085 -0.001)",
  fill: "#e2b434"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1540",
  "data-name": "Caminho 1540",
  d: "M11.425,84.837A14.057,14.057,0,0,0,8.8,80.2a.387.387,0,0,0-.268-.119q-2.634-.01-5.268,0a.359.359,0,0,0-.251.1A13.67,13.67,0,0,0,.261,85.2a5.466,5.466,0,0,0-.034,3.209,3.408,3.408,0,0,0,3.263,2.377c.8-.042,1.6-.007,2.406-.007.588,0,1.177,0,1.765,0a8.583,8.583,0,0,0,1.227-.03,3.47,3.47,0,0,0,2.779-2.7,6.142,6.142,0,0,0-.242-3.209M8.742,87.324a4.045,4.045,0,0,1-.682.511,3.658,3.658,0,0,1-.867.379,3.269,3.269,0,0,1-.913.132A3.44,3.44,0,0,1,4.965,88.1a3.21,3.21,0,0,1-1.054-.694A3.267,3.267,0,0,1,3.2,86.365a3.006,3.006,0,0,1-.118-.327.079.079,0,0,0-.075-.057H2.232a.079.079,0,0,1-.079-.079v-.408a.079.079,0,0,1,.079-.079h.645a.079.079,0,0,0,.079-.085q-.008-.12-.008-.243c0-.04,0-.08,0-.119a.079.079,0,0,0-.079-.082H2.232a.079.079,0,0,1-.079-.079v-.4a.079.079,0,0,1,.079-.079h.74a.079.079,0,0,0,.076-.06,2.947,2.947,0,0,1,.155-.451A3.124,3.124,0,0,1,3.92,82.8,3.354,3.354,0,0,1,5,82.111a3.543,3.543,0,0,1,1.328-.247,3.423,3.423,0,0,1,.913.123,3.741,3.741,0,0,1,.845.347,3.267,3.267,0,0,1,.655.482.079.079,0,0,1,.005.108l-.608.716a.079.079,0,0,1-.116.005,2.647,2.647,0,0,0-.744-.532,2.132,2.132,0,0,0-.931-.219,2.1,2.1,0,0,0-.84.169,2.137,2.137,0,0,0-.685.466,2.162,2.162,0,0,0-.456.689.079.079,0,0,0,.073.11H6.584a.079.079,0,0,1,.079.079v.4a.079.079,0,0,1-.079.079H4.28a.079.079,0,0,0-.079.076c0,.038,0,.077,0,.116a2.393,2.393,0,0,0,.015.269.079.079,0,0,0,.079.069H6.584a.079.079,0,0,1,.079.079V85.9a.079.079,0,0,1-.079.079H4.51a.079.079,0,0,0-.071.115,2.175,2.175,0,0,0,.38.533,2.106,2.106,0,0,0,1.525.639,2.24,2.24,0,0,0,.918-.205,2.787,2.787,0,0,0,.76-.5.079.079,0,0,1,.111,0l.612.643a.079.079,0,0,1,0,.112",
  transform: "translate(0 -75.787)",
  fill: "#e2b434"
}));
function SvgIconCentroCustosIncompleto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-centro-custos-incompleto",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.785,
    height: 15,
    viewBox: "0 0 11.785 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCentroCustosIncompleto);
export default __webpack_public_path__ + "static/media/icon_centro_custos_incompleto.d70b8a0b.svg";
export { ForwardRef as ReactComponent };